import { useMemo } from 'react';
import { Campaign } from '../types/commerce';
import { useStorefrontContent } from './useStorefrontContent';

export function useCarouselSlides() {
  const { campaigns } = useStorefrontContent();
  return useMemo(() => {
    const grouped: Record<string, Campaign[]> = {};
    for (const campaign of campaigns) {
      const placement = campaign.placement ?? 'home';
      (grouped[placement] ??= []).push(campaign);
    }
    return grouped;
  }, [campaigns]);
}
